
import request from '@/axios'

/** 用户 模块 */
export const UserApi = {
  /** 获得基本信息 */
  getUserInfo: async (): Promise<boolean> => {
    return await request.get({ url: `/member/user/get` })
  },

  /** 修改用户密码 */
  updateUserPassword: async (data: any): Promise<boolean> => {
    return await request.put({ url: `/member/user/update-password`, data })
  },

  /** 修改基本信息 */
  updateUserInfo: async (data: any): Promise<boolean> => {
    return await request.put({ url: `/member/user/update`, data })
  },

  /** 重设密码 */
  resetUserPassword: async (data: any): Promise<boolean> => {
    return await request.put({ url: `/member/user/reset-password`, data })
  },
}
